const EnableFocus = {
	init() {
		 document.addEventListener('keydown', function(event) {
			  if (event.key === 'Tab') {
					document.body.classList.add('focus-enabled');
			  }
		 });
	}
}

export default EnableFocus;
